import { apiCall } from "service/apiCall";
import { setLoading, setError, modalToggle } from "./general";
import Cookie from "universal-cookie";
import { get } from "lodash";
import { URL, USER, PASS } from "service/base_url";
import * as actionTypes from "redux/constants/assestment";
import { tabToggle } from "./master";
const cookie = new Cookie();
const token = cookie.get("login_cookie");
const profile = cookie.get("profile_cookie");

export const setBod2Question = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_BOD2_QUESTION,
    payload: data,
  });
};

export const resetBod2Question = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_BOD2_QUESTION,
  });
};

export const setBod2Time = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_BOD2_TIME,
    payload: data,
  });
};

export const setBod2QuestionGap = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_BOD2_QUESTION_GAP,
    payload: data,
  });
};

export const resetBod2QuestionGap = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_BOD2_QUESTION_GAP,
  });
};

export const setBod2GapTime = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_BOD2GAP_TIME,
    payload: data,
  });
};

export const setBod3Question = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_BOD3_QUESTION,
    payload: data,
  });
};

export const resetBod3Question = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_BOD3_QUESTION,
  });
};

export const setBod3Time = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_BOD3_TIME,
    payload: data,
  });
};

export const setBod3QuestionGap = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_BOD3_QUESTION_GAP,
    payload: data,
  });
};

export const resetBod3QuestionGap = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_BOD3_QUESTION_GAP,
  });
};

export const setBod3GapTime = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_BOD3GAP_TIME,
    payload: data,
  });
};

export const setPapiActiveSub = (payload) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_PAPI_ACTIVE_SUB,
    payload,
  });
};
export const setCfitActiveSub = (payload) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_CFIT_ACTIVE_SUB,
    payload,
  });
};
export const setActiveSub = (payload) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_ACTIVE_SUB,
    payload,
  });
};
export const setActivePart = (payload) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_ACTIVE_PART,
    payload,
  });
};
export const resetAssestmentReducer = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_ALL,
  });
};
export const setCountFoto = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_COUNT_FOTO,
    payload: data,
  });
};
export const setQuestion = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_QUESTION,
    payload: data,
  });
};
export const setRecord = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_RECORD,
    payload: data,
  });
};
export const setUpdateBio = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_UPDATE_BIO,
    payload: data,
  });
};
export const setCfit = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_CFIT,
    payload: data,
  });
};
export const setPapi = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_PAPI,
    payload: data,
  });
};
export const resetQuestion = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_QUESTION,
  });
};
export const resetPapi = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_PAPI,
  });
};
export const resetCfit = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_CFIT,
  });
};
export const resetToefl = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_TOEFL,
  });
};
export const setToefl = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_TOEFL,
    payload: data,
  });
};

export const setCfitTime = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_CFIT_TIME,
    payload: data,
  });
};
export const setDiscTime = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_DISC_TIME,
    payload: data,
  });
};
export const setPapiTime = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_PAPI_TIME,
    payload: data,
  });
};
export const setToeflTime = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_TOEFL_TIME,
    payload: data,
  });
};

export const fetchBod2Questions = () => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    let dataReq = {
      url: "/BiofarmaSjtBod2/questions",
      method: "GET",
      data: {
        headers: { Authorization: `Bearer ${token}` },
      },
    };

    let res = await dispatch(apiCall(dataReq));

    if (get(res, "status") === 200) {
      const apiData = get(res, "data", []);

      const transformedData = apiData.map((item, index) => ({
        number: index + 1,
        questionId: item.id,
        category: item.category,
        questionText: item.questionText,
        list_question: item.options.map((opt) => ({
          id: opt.id,
          q: opt.optionText,
          value: opt.value,
          answer: "",
        })),
      }));

      dispatch({
        type: actionTypes.SET_BOD2_QUESTION,
        payload: transformedData,
      });

      dispatch(setLoading(false));
      return transformedData;
    } else {
      dispatch(setLoading(false));
    }
  } catch (error) {
    dispatch(setLoading(false));
  }
};

export const fetchBod2QuestionsGap = () => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    let dataReq = {
      url: "/BiofarmaSjtBod2/questions-gap",
      method: "GET",
      data: {
        headers: { Authorization: `Bearer ${token}` },
      },
    };

    let res = await dispatch(apiCall(dataReq));

    if (get(res, "status") === 200) {
      const apiData = get(res, "data", []);

      const transformedData = apiData.map((item, index) => ({
        number: index + 1,
        questionId: item.id,
        category: item.category,
        questionText: item.questionText,
        options: item.options.map((opt) => ({
          id: opt.id,
          optionText: opt.optionText,
          value: opt.value,
          isSelected: false,
        })),
        selectedAnswer: null,
      }));

      dispatch({
        type: actionTypes.SET_BOD2_QUESTION_GAP,
        payload: transformedData,
      });

      dispatch(setLoading(false));
      return transformedData;
    } else {
      dispatch(setLoading(false));
    }
  } catch (error) {
    dispatch(setLoading(false));
  }
};

export const fetchBod3Questions = () => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    let dataReq = {
      url: "/BiofarmaSjtBod3/questions",
      method: "GET",
      data: {
        headers: { Authorization: `Bearer ${token}` },
      },
    };

    let res = await dispatch(apiCall(dataReq));

    if (get(res, "status") === 200) {
      const apiData = get(res, "data", []);

      const transformedData = apiData.map((item, index) => ({
        number: index + 1,
        id: item.id,
        questionNumber: item.questionNumber,
        category: item.category,
        questionText: item.questionText,
        options: item.options.map((opt) => ({
          id: opt.id,
          optionText: opt.optionText,
          value: opt.value,
          isSelected: false,
        })),
        selectedAnswer: null,
      }));

      dispatch({
        type: actionTypes.SET_BOD3_QUESTION,
        payload: transformedData,
      });

      dispatch(setLoading(false));
      return transformedData;
    } else {
      dispatch(setLoading(false));
    }
  } catch (err) {
    dispatch(setLoading(false));
  }
};

export const fetchBod3QuestionsGap = () => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    let dataReq = {
      url: "/BiofarmaSjtBod3/questions-gap",
      method: "GET",
      data: {
        headers: { Authorization: `Bearer ${token}` },
      },
    };

    let res = await dispatch(apiCall(dataReq));

    if (get(res, "status") === 200) {
      const apiData = get(res, "data", []);

      const transformedData = apiData.map((item, index) => ({
        number: index + 1,
        id: item.id,
        questionNumber: item.questionNumber,
        category: item.category,
        questionText: item.questionText,
        options: item.options.map((opt) => ({
          id: opt.id,
          optionText: opt.optionText,
          value: opt.value,
          isSelected: false,
        })),
        selectedAnswer: null,
      }));

      dispatch({
        type: actionTypes.SET_BOD3_QUESTION_GAP,
        payload: transformedData,
      });

      dispatch(setLoading(false));

      return transformedData;
    } else {
      dispatch(setLoading(false));
    }
  } catch (err) {
    dispatch(setLoading(false));
  }
};

export const postBod2Answer = (data) => async (dispatch) => {
  dispatch(setLoading(true));

  const payload = {
    userId: data.userId,
    answers: data.answers,
  };

  let dataReq = {
    url: "/BiofarmaSjtBod2/user/answer",
    method: "POST",
    data: {
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    },
  };

  let res = await dispatch(apiCall(dataReq));

  if (get(res, "status") === 200) {
    await dispatch(resetBod2Question());
    dispatch(setLoading(false));
    window.location.assign("/portal");
  } else {
    dispatch(setLoading(false));
  }
};

export const postBod2AnswerGap = (data) => async (dispatch) => {
  dispatch(setLoading(true));

  const payload = {
    userId: data.userId,
    answers: data.answers,
  };

  let dataReq = {
    url: "/BiofarmaSjtBod2/user/answer-gap",
    method: "POST",
    data: {
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    },
  };

  let res = await dispatch(apiCall(dataReq));

  if (get(res, "status") === 200) {
    await dispatch(resetBod2QuestionGap());
    dispatch(setLoading(false));
    window.location.assign("/portal");
  } else {
    dispatch(setLoading(false));
  }
};

export const postBod3Answer = (data) => async (dispatch) => {
  dispatch(setLoading(true));

  const payload = {
    userId: data.userId,
    answers: data.answers,
  };

  let dataReq = {
    url: "/BiofarmaSjtBod3/user/answer",
    method: "POST",
    data: {
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    },
  };

  let res = await dispatch(apiCall(dataReq));

  if (get(res, "status") === 200) {
    await dispatch(resetBod3Question());
    dispatch(setLoading(false));
    window.location.assign("/portal");
  } else {
    dispatch(setLoading(false));
  }
};

export const postBod3AnswerGap = (data) => async (dispatch) => {
  dispatch(setLoading(true));

  const payload = {
    userId: data.userId,
    answers: data.answers,
  };

  let dataReq = {
    url: "/BiofarmaSjtBod3/user/answer-gap",
    method: "POST",
    data: {
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    },
  };

  let res = await dispatch(apiCall(dataReq));

  if (get(res, "status") === 200) {
    await dispatch(resetBod3QuestionGap());
    dispatch(setLoading(false));
    window.location.assign("/portal");
  } else {
    dispatch(setLoading(false));
  }
};

export const postJawaban = (data) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: "/disc/user/answer",
    method: "POST",
    data: { data: data, headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    await dispatch(resetQuestion());
    dispatch(setLoading(false));
    window.location.assign("/portal");
    // dispatch(tabToggle('done','assestment'))
  } else {
    dispatch(setLoading(false));
    // dispatch(setError('The Email or password is incorrect. Please try again '))
  }
};

export const postCfit = (data) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: "/cfit/answer",
    method: "POST",
    data: { data: data, headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    await dispatch(resetCfit());
    dispatch(setLoading(false));

    window.location.assign("/portal");
    // dispatch(tabToggle('done','assestment'))
  } else {
    dispatch(setLoading(false));
    // dispatch(setError('The Email or password is incorrect. Please try again '))
  }
};
export const postPapi = (data) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: "/mpt/answer",
    method: "POST",
    data: { data: data, headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    await dispatch(resetPapi());
    dispatch(setLoading(false));

    window.location.assign("/portal");
    // dispatch(tabToggle('done','assestment'))
  } else {
    dispatch(setLoading(false));
    // dispatch(setError('The Email or password is incorrect. Please try again '))
  }
};
export const postToefl = (data) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: "/toefl/answer",
    method: "POST",
    data: { data: data, headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    await dispatch(resetToefl());
    dispatch(setLoading(false));

    window.location.assign("/portal");
    // dispatch(tabToggle('done','assestment'))
  } else {
    dispatch(setLoading(false));
    // dispatch(setError('The Email or password is incorrect. Please try again '))
  }
};
export const postInfoPeserta = (data) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: "/disc/user/info",
    method: "POST",
    data: { data: data, headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    return res;
  } else {
    dispatch(setLoading(false));
    // dispatch(setError('The Email or password is incorrect. Please try again '))
  }
};
export const postFoto = (data, count_foto) => async (dispatch) => {
  // dispatch(setLoading(true))
  let dataReq = {
    url: "/assess/photo",
    method: "POST",
    data: { data: data, headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    return res;
  }
};
